module.exports = __webpack_public_path__ + "assets/img/fotolia_177579430.269b51dd.jpg";